import axios from "axios"
axios.get("/config.json").then((config) => {
  window.processEnv = config.data
  require("./initialize.js")
})
